import React, { useState, useEffect, useRef } from 'react';
import { Link } from './Link';
import Modal from './Modal';

export const RestaurantSignUp = ({ noModal }) => {
  const [showModal, setShowModal] = useState(false);
  const firstInput = useRef(null);

  const openModal = event => {
    event.preventDefault();
    setShowModal(true);
  };

  const closeModal = event => {
    event.preventDefault();
    setShowModal(false);
  };

  useEffect(() => {
    if (firstInput && firstInput.current) firstInput.current.focus();
  }, [showModal]);

  if (noModal) {
    return (
      <Link to="/restaurant-sign-up" className="button primary">
        Request a 10-minute demo
      </Link>
    );
  }

  return (
    <>
      <a href="#open" onClick={openModal} className="button primary">
        Request a 10-minute demo
      </a>
      <Modal active={showModal} title="Request a 10 minute demo" closeModal={closeModal}>
        <form
          name="restaurant-demo"
          className="form"
          method="POST"
          action="/thank-you"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
        >
          <label className="hidden" htmlFor="bot-field">
            Don’t fill this out if you're human: <input name="bot-field" />
          </label>
          <input type="hidden" name="form-name" value="restaurant-demo" />
          <div className="field split">
            <label htmlFor="first-name">
              <input
                type="text"
                id="first-name"
                name="first-name"
                placeholder="First name"
                aria-label="First name"
                aria-labelledby="first-name"
                ref={firstInput}
                required
              />
              <span>First name</span>
            </label>
          </div>
          <div className="field split">
            <label htmlFor="last-name">
              <input
                type="text"
                id="last-name"
                name="last-name"
                placeholder="Last name"
                aria-label="Last name"
                aria-labelledby="last-name"
                required
              />
              <span>Last name</span>
            </label>
          </div>
          <div className="field">
            <label htmlFor="restaurant">
              <input
                type="text"
                id="restaurant"
                name="restaurant"
                placeholder="Restaurant Name"
                aria-label="Restaurant Name"
                aria-labelledby="restaurant"
                required
              />
              <span>Restaurant Name</span>
            </label>
          </div>
          <div className="field">
            <label htmlFor="postcode">
              <input
                type="text"
                id="postcode"
                name="postcode"
                placeholder="Restaurant Postcode"
                aria-label="Restaurant Postcode"
                aria-labelledby="postcode"
                required
              />
              <span>Restaurant Postcode</span>
            </label>
          </div>
          <div className="field">
            <label htmlFor="phone">
              <input
                type="text"
                id="phone"
                name="phone"
                placeholder="Best contact number"
                aria-label="Best contact number"
                aria-labelledby="phone"
                required
              />
              <span>Best contact number</span>
            </label>
          </div>
          <button type="submit" className="button primary">
            Send
          </button>
        </form>
      </Modal>
    </>
  );
};
